import requestAction from '../../utils/requestAction'
import SchoolContact, { SchoolContactInput } from '../../models/SchoolContact';

export const bulkUpsertContacts = (records: (SchoolContact|SchoolContactInput)[]) =>
  requestAction('SCHOOL_CONTACT_BULK_UPSERT')('school-contacts/bulk', 'POST', { records })
